import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const StarIcon = ({
  color = '#000',
  size = 30,
  backgroundColor = colors('grey'),
  circled = false,
  fill = false,
}) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 19.8 19"
    >
      <g transform="translate(1 1)">
        <path
          d="M13.968,197l2.75,5.6,6.15.9-4.45,4.356L19.469,214l-5.5-2.9-5.5,2.9,1.051-6.151-4.45-4.356,6.15-.9Z"
          transform="translate(-5.068 -197)"
          fill={fill ? color : 'none'}
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
